<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="结账月份">
                                <el-date-picker
                                        v-model="yearMonth"
                                        size="medium"
                                        type="month"
                                        value-format="yyyy-MM"
                                        format="yyyy-MM"  placeholder="选择年月">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-monitor" type="primary" size="medium" @click="monthcheck">
                                    开始结账
                                </el-button>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
    </div>
</template>

<script>


    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
        },
        data() {
            return {
                searBarHeight: 70,
                yearMonth:this.$store.state.loginInfo.MonthAccount,
            }
        },
        methods: {
            search() {

                let searchData = {
                    yearMonth:this.yearMonth
                }
                this.$emit('search',searchData);
            },
            monthcheck() {

                if(this.yearMonth==null || this.yearMonth==''){
                    this.$message({message: '请选择结账月份', type: 'error'});
                    return false;
                }
                this.$emit('monthCheck',this.yearMonth);
            },
        }
    }
</script>

